import React, { useState, useEffect } from 'react';
import Sidebar from '@/components/Sidebar';
import { cn } from '@/lib/utils';

const Layout = ({ children, user, onLogout }) => {
  // Start with sidebar closed on mobile, open on desktop
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth >= 1024; // lg breakpoint
    }
    return true;
  });

  const isPartner = user?.role === 'parceiro';

  return (
    <div className="min-h-screen bg-background">
      <Sidebar 
        user={user} 
        onLogout={onLogout}
        isOpen={sidebarOpen}
        setIsOpen={setSidebarOpen}
      />
      <main
        className={cn(
          "transition-all duration-300 min-h-screen",
          sidebarOpen ? "lg:ml-64" : "lg:ml-20",
          "pt-16 lg:pt-0"
        )}
      >
        {children}
      </main>
    </div>
  );
};

export default Layout;
